// Czysta decyzja odczytu koszyka: czy zachować poprzedni (dobry) koszyk zamiast
// nadpisać go pustką z powodu chwilowo utraconej sesji PS.
//
// Kontekst: backend zwraca 422 "Cookie is not set", gdy sesja PS jest chwilowo
// nieczytelna (wyścig GET-przed-POST, in-app browser, cookie z poprzedniego
// deployu). Proxy /api/store/cart mapuje to na pusty koszyk z flagą sessionLost.
// useCartQuery leci na KAŻDYM mount/nawigacji (refetchOnMount:'always'), w tym
// tuż po dodaniu do koszyka — więc bez tego guardu pojedynczy przejściowy blip
// nadpisywał w cache dobry, właśnie zapełniony koszyk pustką. To była główna,
// potwierdzona w kodzie przyczyna zgłoszeń „dodałem, a koszyk pusty".
//
// Bezpieczeństwo: realnie pusty koszyk (usunięto ostatnią pozycję, koszyk po
// zamówieniu, pierwsza wizyta) przychodzi z HTTP 200 BEZ sessionLost, więc tu
// NIE jest maskowany — pokazujemy pusto zgodnie z prawdą.

export interface CartQueryLike {
  itemsCount: number
  sessionLost?: boolean
}

export interface ResolveCartQueryResult<T extends CartQueryLike> {
  // Dane, które query ma ostatecznie zwrócić (poprzedni koszyk albo nowy odczyt).
  data: T
  // true, gdy zachowano poprzedni koszyk zamiast pustego sessionLost.
  keptPrevious: boolean
}

export function resolveCartQueryResult<T extends CartQueryLike>(
  next: T,
  previous: T | undefined,
): ResolveCartQueryResult<T> {
  if (next?.sessionLost && previous && previous.itemsCount > 0) {
    return { data: previous, keptPrevious: true }
  }

  return { data: next, keptPrevious: false }
}
